import $ from "cash-dom";
import anime from "animejs/lib/anime.es.js";

export const popupComponent = (root) => {
    const $root = $(root);
    const rootEle = $root.get(0);
    const $acceptButton = $root.find('.accept-button');

    const show = () => {
        rootEle.style.opacity = '0';
        rootEle.style.display = 'flex';
        anime({
            targets: rootEle,
            opacity: 1,
            duration: 150,
            easing: 'easeInSine',
        })
    };
    const hide = () => {
        anime({
            targets: rootEle,
            opacity: 0,
            duration: 500,
            easing: 'easeInSine',
            complete() {
                rootEle.style.display = 'none';
            },
        })
    };

    $acceptButton.each((i, acceptButton) => acceptButton.onclick = hide);
    rootEle.onclick = hide;
    $(rootEle).children().each((i, child) => {
        const onClick = child.onclick;
        child.onclick = (e) => {
            e.stopPropagation();
            if (onClick)
                return onClick(e);
        };
    });

    return {
        show,
        hide,
    };
};
